// import SoundManager from './SoundManager.js';
import Phaser from 'phaser'

export default class Boot extends Phaser.Scene {

    constructor() {
        super({
            key: "Boot"
        })
    }
    init(data){
        console.log('Start :',this.scene.key, data);

        var startScene = "Menu"
        var value = this.getUrlParam('scene', 'Empty')
        if(value!= undefined && value!=null && value!="" && value!='Empty'){
            startScene = value
        }

        var isMobile = /Mobi|Android/i.test(navigator.userAgent) || Phaser.Input.Touch.enabled;

        this.game.data = {
            sceneStopped : '',
            sceneRunning : '',
            'Preloader' : {
                next : startScene,
                sound: ''
            },
            'Menu' : {
                next : 'Video',
                sound: ''
            },
            'Video' : {
                next : 'Game1',
                sound: ''
            },
            'Game1' : {
                next : 'Game2',
                sound: ''
            },
            'Game2' : {
                next : 'Fin',
                sound: ''
            },
            isMobile: isMobile,
        }
    }

    preload() {

        // Preloader
        // Charge les fichiers pour le preloader

        // this.load.on('complete', function () {
            this.scene.start("Preloader");
        // }, this);

    }

    getUrlVars() {
        var vars = {};
        var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
            vars[key] = value;
        });
        return vars;
    };
    
    getUrlParam(parameter, defaultvalue) {
        var urlparameter = defaultvalue;
        if (window.location.href.indexOf(parameter) > -1) {
            urlparameter = this.getUrlVars()[parameter];
        }
        return urlparameter;
    };
}